const notices = document.querySelectorAll('.js-notice');

export const notice = () => {
	notices.forEach((notice) => {
		const noticeClose = notice.querySelector('.js-notice__close');
		noticeClose.addEventListener('click', () => {
			notice.classList.add('is-hidden');
		});
	});
};
